import React from 'react';
import { WriteoffApprovalLevelsDisplay } from '../sections/WriteoffApprovalLevelsDisplay';

interface WriteoffConfigTabProps {
  centerId: string;
  initialConfig: any;
}

export const WriteoffConfigTab: React.FC<WriteoffConfigTabProps> = ({
  centerId,
  initialConfig
}) => {
  return (
    <WriteoffApprovalLevelsDisplay
      centerId={centerId}
      initialConfig={initialConfig}
    />
  );
};
